import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetByRole } from '../../service/UserService';

export default function UserList() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode
  } = useGlobalContext();

  const [users, setUsers] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUserList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetByRole("member", "free", currentPage, limit, keyword);
      setUsers(response.users || []);
      console.log("Fetched users:", response.users);

      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserList(page);
  }, [page]);

  const handleSearch = () => {
    setPage(1);
    fetchUserList(1);
  };

  return (
    <>
      <Helmet>
        <title>Free Member List | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Free Member List</h1>
            <span><Link to="/"> Dashboard </Link> / Free Member List</span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <form>
                  <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Keyword</label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                          />
                          <button className="btn btn-outline-secondary" type="button" onClick={handleSearch}>
                            <FontAwesomeIcon icon="fa-solid fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="p-2">
                        <div className="input-group p-4">
                          <Link className="btn btn-success" to="/members/add">
                            <FontAwesomeIcon icon="fa-solid fa-plus" /> Add Member
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className='table-content'>
                  <div className="mobile-scroll">
                    <table className='table table-bordered table-condensed'>
                      <thead>
                        <tr>
                          <th>Sl.no</th>
                          <th>Image</th>
                          <th>Member No.</th>
                          <th>Name</th>
                          <th>Mobile / Password</th>
                          <th>Email </th>
                          <th>City</th>
                          <th>Gender</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users && users.length > 0 ? (
                          users
                            .map((user, index) => (
                              <tr key={user.id}>
                                <td>{(page - 1) * limit + index + 1}</td>
                                <td>
                                    {user.image ? (
                                      <img
                                        src={`${config.imageBasePath}/user/${user.id}.${user.image}`}
                                        alt={user.name}
                                        className='img-fluid image-xs'
                                      />
                                    ) : (
                                      <span className="text-muted" style={{ fontSize: '12px' }}>No Profile Picture</span>
                                    )}
                                  </td>
                                <td>{`A${user.id.toString().padStart(5, '0')}`}</td>
                                <td>{user.name}</td>
                                <td>{user.mobile}
                                  <br />
                                  <span style={{ fontSize: "12px" }}>
                                    [ Psw : {user.password} ]
                                  </span>
                                </td>
                                <td>
                                  {user.email}
                                </td>
                                <td>{user.city.name}</td>
                                <td>{user.gender.name}</td>
                                <td>{user.status}</td>
                                <td>
                                  <Link to={`/members/edit/${user.id}`} className='btn btn-sm btn-primary' title="Edit Member">
                                    <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                                  </Link> &nbsp;
                                  <Link to={`/members/password/${user.id}`} className='btn btn-sm btn-warning' title="Change Password">
                                    <FontAwesomeIcon icon="fa-solid fa-key" />
                                  </Link> &nbsp;
                                  <Link to={`/members/activate/${user.id}`} className='btn btn-sm btn-danger' title="Activate">
                                    <FontAwesomeIcon icon="fa-solid fa-user" /> Activate
                                  </Link>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr><td colSpan="9" className="text-center">No members found</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
